var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuClientiLista(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.85,6.52c-8.18,0-15.75,2.56-21.98,6.91,10.82,9.26,17.7,23.01,17.7,38.33,0,10.88-3.47,20.95-9.35,29.2,4.24,1.61,8.83,2.49,13.63,2.49,21.25,0,38.47-17.22,38.47-38.47S152.09,6.52,130.85,6.52Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1,
    cy: 51.76,
    r: 42.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.32,148.65c-14.87-31.9-45.1-54-67.48-54-8.92,0-19.09,3.52-29.04,9.77,22.11,10.09,43.67,31.72,55.91,57.98,1.7,3.64,2.55,7.51,2.59,11.37h22.02c12.91,0,21.45-13.42,15.99-25.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.75,193.48c14.21,0,23.61-14.76,17.6-27.64-16.37-35.11-49.63-59.43-74.26-59.43S18.21,130.73,1.84,165.84c-6,12.88,3.39,27.64,17.6,27.64h113.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClientiLista);
export default __webpack_public_path__ + "static/media/menu-clienti-lista.adea1d66457602e981c7794c630466f3.svg";
export { ForwardRef as ReactComponent };